import React, { Component } from "react";
import { withTranslation } from 'react-i18next';
import Moment from 'moment';

import Section from './Section'
import CalendarRow from './CalendarRow'

class CalendarSection extends Component {

  generateCalendarHeader = (year, isCustom, start_month = null, end_month = null) => {
    var begin_year = null
    var end_year = null

    if (start_month) {
      begin_year = Moment(new Date(year, start_month - 1, 1)).format('ll')
      end_year = Moment(new Date(parseInt(year) + 1, end_month - 1, 31)).format('ll')
    } else {
      begin_year = Moment(new Date(year, 0, 1)).format('ll')
      end_year = Moment(new Date(year, 11, 31)).format('ll')
    }

    return !isCustom ? `${begin_year} - ${end_year}` : ""
  }

  render() {
    const { sections, startMonth, endMonth, t, calendarType } = this.props
    const isCustom = this.props.isCustom || false
    var title = t("StockAwards.NoAwardsMessage")

    if (!sections || sections.length <= 0) {
      title = t("StockAwards.NoAwardsMessage")
    } else if (calendarType === "calendar-year") {
      title = t('StockAwards.CalendarSection.CalendarTitle', { years: sections.length })
    } else if (calendarType === "comp-year") {
      title = t('StockAwards.CalendarSection.CompTitle', { years: sections.length })
    } else if (calendarType === "custom") {
      if (!(sections.length === 1 && sections[0].remaining.length === 0 && sections[0].completed.length === 0))
        title = t('StockAwards.CalendarSection.CustomTitle')
    }

    return (
      <Section
        sectionId={`calendar_section_${this.props.sectionId}`}
        sectionTitle={title}
        className={this.props.className || 'calendar-year-view'}
        showLink={false}>
        {sections && sections.map((section, index) => {
          return (
            <CalendarRow
              rowId={`calendar_section_${this.props.sectionId}_calendar_row_${index}`}
              title={this.generateCalendarHeader(section.year, isCustom, startMonth, endMonth)}
              subTitle={!isCustom ? t('StockAwards.CalendarSection.SubTitle', { rsus: section.rsus, awards: section.awards.length }) : ""}
              completedVests={section.completed}
              remainingVests={section.remaining}
              broker={this.props.broker}
              key={`section_${index}`}
              onSelectCalendarMenuItem={this.props.onSelectCalendarMenuItem}
              onChangePaymentMethod={this.props.onChangePaymentMethod}
              isCustom={isCustom}
              year={section.year}
            />
          )
        })
        }

      </Section>
    )
  }
}

export default withTranslation("translations")(CalendarSection)

